const resetPassword = {
  title: "Reset Password",
  labels: {
    oldPassword: "current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password"
  },
  placeholders: {
    oldPassword: "Enter the temporary password",
    newPassword: "Enter the new password",
    confirmNewPassword: "Confirm the new password"
  }
};

export default resetPassword;
